module.exports = __webpack_public_path__ + "static/media/plusIconSvg.14260a37.svg";